import styled, { css } from 'styled-components';

type Variant = 'primary' | 'ghost' | 'default';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps {
  $variant?: Variant;
  $size?: Size;
}

const sizeStyles = {
  sm: css`
    padding: 6px 12px;
    font-size: ${(p) => p.theme.step[1]}px;
  `,
  md: css`
    padding: 10px 16px;
    font-size: ${(p) => p.theme.step[3]}px;
  `,
  lg: css`
    padding: 14px 22px;
    font-size: ${(p) => p.theme.step[5]}px;
  `,
} as const;

const variantStyles = {
  primary: css`
    background: ${(p) => p.theme.color.accent.amber};
    color: ${(p) => p.theme.color.bg[0]};
    border: 1px solid ${(p) => p.theme.color.accent.amber};

    &:hover {
      background: ${(p) => p.theme.color.accent.amberBright};
    }
  `,
  ghost: css`
    background: transparent;
    color: ${(p) => p.theme.color.text[0]};
    border: 1px solid ${(p) => p.theme.color.border.med};

    &:hover {
      border-color: ${(p) => p.theme.color.border.strong};
      background: ${(p) => p.theme.color.bg[2]};
    }
  `,
  default: css`
    background: ${(p) => p.theme.color.bg[2]};
    color: ${(p) => p.theme.color.text[0]};
    border: 1px solid ${(p) => p.theme.color.border.soft};

    &:hover {
      background: ${(p) => p.theme.color.bg[3]};
    }
  `,
} as const;

export const Button = styled.button<ButtonProps>`
  font-family: inherit;
  font-weight: 500;
  letter-spacing: 0.01em;
  border-radius: 6px;
  cursor: pointer;
  transition: background 160ms ${(p) => p.theme.ease}, border-color 160ms ${(p) => p.theme.ease};

  ${(p) => sizeStyles[p.$size ?? 'md']}
  ${(p) => variantStyles[p.$variant ?? 'default']}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
